import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';

export const CardHeader = styled(Card.Header)`
  background-color: ${props => props.theme.colors.background.primary};
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  margin-bottom: 32px;
  padding: 24px 32px;

  ${props => props.theme.media.small`
    padding: 24px;
  `}
`;
